import { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { IPermissionProps } from "../../models/Login";
import { Table } from "./Table";

export const Incentives = (permissions: IPermissionProps) => {
    const toast = useRef<any>();
    return (
        <>
            <Table toast={toast}/>
            <Toast ref={toast} />
        </>
    );
}